import React, { useState, useEffect, createContext } from 'react';

export const LocationContext = createContext();

export const LocationProvider = ({ children }) => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        async function fetchData() {
            const response = await fetch('https://angelswing-frontend-test-serverless-api.vercel.app/api/locations/');
            const data = await response.json();
            setData(data);
            setLoading(false)
        };

        fetchData()

    }, [])

    return (
        <LocationContext.Provider value={[loading, data, setData]}>
            {children}
        </LocationContext.Provider>
    )
}